import React from "react";
import { UpdatePaymentPlanIcon } from "icons/dashboard/updatePlanIcon";
import { EyeIcon } from "icons/payments/EyeIcon";
import { CloseIcon } from "icons/payments/CloseIcon";
import { useTid } from "utils/testid";

interface UpdatePlanHeaderProps {
  id: string;
  onClose: () => void;
  onPreview: () => void;
  onDispatch: (action: any) => Promise<any>;
}

const UpdatePlanHeader: React.FC<UpdatePlanHeaderProps> = ({
  id,
  onClose,
  onPreview,
  onDispatch,
}) => {
  const tid = useTid();

  return (
    <div
      className="flex items-center justify-between w-full pb-5 lg:px-0 px-5"
      data-testid={tid(`update-plan-${id}-header`)}
    >
      <div className="flex items-center gap-2">
        <UpdatePaymentPlanIcon
          aria-hidden="true"
          strokeColor="var(--color-txt-primary)"
          width="24"
          height="24"
        />
        <p className="text-[26px] text-txtPrimary font-medium leading-[30px]">
          Update Plan
        </p>
      </div>
      <div className="flex items-center gap-4">
        <div
          role="button"
          tabIndex={0}
          aria-label="Preview updated payment plan"
          data-testid={tid(`update-plan-${id}-preview-button`)}
          className="flex items-center gap-1 cursor-pointer"
          onClick={onPreview}
        >
          <EyeIcon
            aria-hidden="true"
            strokeColor="var(--color-btn-primary-active)"
            width="24"
            height="24"
          />
          <p className="text-lg font-medium text-btnPrimaryActive leading-normal hover:!text-btnPrimaryHover">
            Preview
          </p>
        </div>

        <span
          role="button"
          tabIndex={0}
          aria-label="Close update plan"
          data-testid={tid(`update-plan-${id}-close-button`)}
          onClick={async () => {
            onClose();
            await onDispatch({ type: "resetDuplicateOrder" });
            await onDispatch({ type: "resetCheckDuplicatePayment" });
            await onDispatch({
              type: "updateCheckAmountState",
              payload: false,
            });
            await onDispatch({ type: "onSetShowDisclosure", payload: false });
          }}
          className="cursor-pointer p-2 rounded-full hover:!bg-bgSecondary"
        >
          <CloseIcon aria-hidden="true" />
        </span>
      </div>
    </div>
  );
};

export default UpdatePlanHeader;
